export default {
  aigc_text2sql_title: 'Text2SQL',
  // 聊天框内的文本
  aigc_text2sql_chat_input_placeholder: '请输入问题以生成SQL。',
  aigc_text2sql_first_message:
    '你好！欢迎来到Text2SQL~您可以将任务发送给Text2SQL，让它选择相关表，并进一步为您生成SQL。例如：',
  aigc_text2sql_question_one: '上周新注册的男性',
  aigc_text2sql_question_two: '有多少iOS用户',
  aigc_text2sql_generate_sql: '基于相关表生成SQL',
  aigc_text2sql_generate_sql_again: '基于相关表重新生成SQL',
  aigc_text2sql_generate_table: '重新生成相关表',
  aigc_text2sql_chat_loading: '生成相关表中...',
  aigc_text2sql_sql_loading: '正在生成SQL语句...',
  aigc_text2sql_chat_stop: '停止生成',
  aigc_text2sql_chat_clear: '清空内容',

  // 表格内的文本
  aigc_text2sql_table_rebuild: '重新生成表格',
  aigc_text2sql_relevant_table: '相关表',
  aigc_text2sql_table_edit_relevant: '编辑相关表',
  aigc_text2sql_table_database: '库名',
  aigc_text2sql_table: '表名',
  aigc_text2sql_table_column_name: '列名',
  aigc_text2sql_table_data_type: '类型',
  aigc_text2sql_table_description: '表描述',
  aigc_text2sql_table_operation: '操作',
  aigc_text2sql_table_details: '详情',
  aigc_text2sql_table_delete: '删除',
  aigc_text2sql_table_total: '张表已选',
  // SQL结果内的文本
  aigc_text2sql_sql_title: '操作指引',
  aigc_text2sql_sql_result_title: '生成结果',
  aigc_text2sql_sql_error: '从所选的相关表无法针对该问题生成结果',
  aigc_text2sql_sql_rebuild: '重新生成SQL',
  aigc_text2sql_sql_change: '数据源已被修改。请重新生成SQL',
  aigc_text2sql_sql_copy: '拷贝SQL',
  aigc_text2sql_sql_copied: '已复制',
  aigc_text2sql_sql_edit: '编辑SQL',
  aigc_text2sql_sql_save: '保存',
  aigc_text2sql_sql_save_success: '保存成功',
  aigc_text2sql_sql_cancel: '取消',
  aigc_text2sql_feedback_title: '反馈',
  aigc_text2sql_feedback_placeholder: '留下你的反馈',
  aigc_text2sql_syntax_fixes: '语法修复',
  aigc_text2sql_syntax_retry_fixes: '请尝试对语法问题进行修复',
  aigc_text2sql_syntax_issue: '正在尝试修复语法问题...',
  aigc_text2sql_syntax_completed: '自动修复已完成',
  aigc_text2sql_syntax_check_passed: '已通过TBDS的SQL语法检测',



  // 空文本
  aigc_text2sql_empty: '此处将根据您的问题自动选择相关表格。',
  aigc_text2sql_no_data: '没有找到与该问题相关的表格',
  aigc_text2sql_modal_is_ok: '确定要删除该表吗？',
  aigc_text2sql_modal_main_desc: '此操作无法撤回，您确定要删除该表吗？',
  aigc_text2sql_operational_one_title: '输入任务',
  aigc_text2sql_operational_one_content_first: '清楚地描述您的任务并发送给Text2SQL。',
  aigc_text2sql_operational_two_title: '确认相关表',
  aigc_text2sql_operational_two_content_first: `等待系统根据输入的任务给选择的相关表后,`,
  aigc_text2sql_operational_two_content_second: `可编辑并确认最终正确选取相关表。(待优化)`,
  aigc_text2sql_operational_three_title: '优化SQL',
  aigc_text2sql_operational_three_content_first: '请等待系统根据任务和所选的相关表生成SQL语句',
  aigc_text2sql_operational_three_content_second: '然后使用对话框或编辑器针对SQL代码,',
  aigc_text2sql_operational_three_content_last_message: '进行优化。',
};
